import React from 'react'
import { Spinner, Flex } from '@chakra-ui/react'

export default function Spin(props) {
  return (
    <Flex justifyContent='center' alignItems='center'>
      <Spinner size={props.size || 'sm'} {...props} />
    </Flex>
  )
}
